import type { Fx } from '@tectonics/prs/money';
import { ReceiptGetter, type Receipt } from '../types';

export const getFX: ReceiptGetter<Fx> = ({ fx }: Receipt): Fx => fx;
